import React from 'react';
import DatePicker from 'react-datepicker';
import SelectProvice from './select';

function SearchBox(props) {
  const {
    listProvinces,
    searchMarketPrices,
    setKeyword,
    setProvinceId,
    setCatalogueId,
    catalogueId,
    date,
    keyword,
    setDate,
    fetchMarketPricesByCatalogue,
    agriculturalType,
    reset,
    setReset,
    fetchFollowingMarketPrice,
    page,
  } = props;

  const resetSearch = () => {
    setReset(true);
    setKeyword('');
    setDate(null);
    setProvinceId(null);
    setCatalogueId('');
    if (agriculturalType === 'follow') {
      fetchFollowingMarketPrice({ page: 1 });
    } else {
      fetchMarketPricesByCatalogue({
        page: 1,
        catalogue_type: agriculturalType === 'all' || agriculturalType === 'follow' ? '' : agriculturalType,
      });
    }
  };

  return (
    <>
      <div className="search-box">
        <form>
          <div className="row">
            {page !== 'marketFilterCatalogue' && (
              <div className="col-md-3 col-sm-3 col-xs-12">
                <input
                  className="form-control mb-2"
                  type="text"
                  placeholder="Mặt hàng"
                  value={keyword}
                  onChange={e => setKeyword(e.target.value)}
                />
              </div>
            )}

            {/* Chỉnh sửa: thay hidden={true} thành style={{ display: 'none' }} */}
            <input
              className="form-control mb-2"
              type="text"
              placeholder="Mặt hàng"
              value={catalogueId ?? ''}
              style={{ display: 'none' }}
              readOnly
            />

            <div
              className={
                page !== 'marketFilterCatalogue'
                  ? 'col-md-3 col-sm-3 col-xs-12 mb-2'
                  : 'col-md-4 col-sm-4 col-xs-12 mb-2'
              }
            >
              <div className="position-relative">
                <SelectProvice
                  listProvinces={listProvinces}
                  setProvinceId={setProvinceId}
                  isReset={reset}
                  setReset={setReset}
                />
              </div>
            </div>

            <div
              className={
                page !== 'marketFilterCatalogue'
                  ? 'col-md-3 col-sm-3 col-xs-12 position-relative'
                  : 'col-md-4 col-sm-4 col-xs-12 position-relative'
              }
            >
              <label className="date-search-market-price">
                <DatePicker
                  className="form-control mb-2"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Chọn ngày"
                  selected={date ? new Date(date) : ''}
                  onChange={date => setDate(date)}
                />
                <span className="icon-calendar"></span>
              </label>
            </div>

            <div
              className={
                page !== 'marketFilterCatalogue'
                  ? 'col-md-3 col-sm-3 col-xs-12 btn-pd d-flex align-items-center'
                  : 'col-md-4 col-sm-4 col-xs-12 btn-pd d-flex align-items-center'
              }
            >
              <button
                type="button"
                className="btn btn-sm btn-primary text-center mr-2"
                onClick={searchMarketPrices}
              >
                Tìm kiếm
              </button>
              <button
                type="button"
                className="btn btn-sm btn-warning text-center text-uppercase"
                onClick={resetSearch}
              >
                Bỏ lọc
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default SearchBox;
